<template>
    <div>
        <div class="d-flex justify-content-between mb-4">
            <div>
                <h1 class="mb-0" :id="details.id">{{ details.fullname }}</h1>
            </div>
            <div>
                <button
                    type="button"
                    class="btn"
                    @click="editProfile"
                    style="background-color: #e1e1e1"
                    :disabled="
                        !details.isactive || !_hasAccess('setting.staff.update')
                    "
                >
                    Edit Profile
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4">
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="firstname">First Name:</label>
                    </div>
                    <div class="col-sm-8">
                        <span id="firstname">{{ details.firstname }}</span>
                    </div>
                </div>
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="lastname">Last Name:</label>
                    </div>
                    <div class="col-sm-8">
                        <span id="lastname">{{ details.lastname }}</span>
                    </div>
                </div>
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="title">Title:</label>
                    </div>
                    <div class="col-sm-8">
                        <span id="title">{{ details.title }}</span>
                    </div>
                </div>
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="role">Role:</label>
                    </div>
                    <div class="col-sm-8">
                        <span id="role">{{ details.role_label }}</span>
                    </div>
                </div>
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="provider">Provider:</label>
                    </div>
                    <div class="col-sm-8">
                        <span id="provider">{{
                            details.is_provider == 1 ? "Yes" : "No"
                        }}</span>
                    </div>
                </div>
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="payType">Pay Type:</label>
                    </div>
                    <div class="col-sm-8">
                        <span id="payType">{{
                            details.pay_type == 1 ? "Hourly" : "Salaried"
                        }}</span>
                    </div>
                </div>
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="license">License:</label>
                    </div>
                    <div class="col-sm-8">
                        <span id="license">{{ details.license }}</span>
                    </div>
                </div>
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="dea">DEA:</label>
                    </div>
                    <div class="col-sm-8">
                        <span id="dea">{{ details.dea }}</span>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="email"
                            >Email:
                            <i
                                class="fa fa-info-circle"
                                v-b-tooltip.hover="{
                                    placement: 'top',
                                    title: 'Username for login'
                                }"
                                style="color: #cccccc"
                            ></i
                        ></label>
                    </div>
                    <div class="col-sm-8">
                        <span id="email">{{ details.email }}</span>
                    </div>
                </div>
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="homeCountryCode">Home:</label>
                    </div>
                    <div class="col-sm-8">
                        <span id="homePhone">{{ details.home }}</span>
                    </div>
                </div>
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="mobileCountryCode">Mobile:</label>
                    </div>
                    <div class="col-sm-8">
                        <span id="mobilePhone">{{ details.mobile }}</span>
                    </div>
                </div>
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="address">Address:</label>
                    </div>
                    <div class="col-sm-8">
                        <span id="address">{{ details.address }}</span>
                    </div>
                </div>
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="city">City:</label>
                    </div>
                    <div class="col-sm-8">
                        <span id="city">{{ details.city }}</span>
                    </div>
                </div>
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="state">State:</label>
                    </div>
                    <div class="col-sm-8">
                        <span id="state">{{ details.state }}</span>
                    </div>
                </div>
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="zipcode">Zipcode:</label>
                    </div>
                    <div class="col-sm-8">
                        <span id="zipcode">{{ details.zipcode }}</span>
                    </div>
                </div>
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="country">Country:</label>
                    </div>
                    <div class="col-sm-8">
                        <span id="country">{{ details.country }}</span>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="restricted_after_office_access"
                            >After-Hours:</label
                        >
                    </div>
                    <div class="col-sm-8">
                        <span id="restricted_after_office_access">{{
                            details.restricted_after_office_access == 1
                                ? "Can log in after hours"
                                : "Cannot log in after hours"
                        }}</span>
                    </div>
                </div>
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="timezone">Timezone:</label>
                    </div>
                    <div class="col-sm-8">
                        <span id="timezone">{{
                            details.timezone == 0
                                ? "Default to clinic timezone"
                                : details.timezone
                        }}</span>
                    </div>
                </div>
                <div
                    v-if="!isNotifcationFeatureEnabled"
                    class="row form-group p-1"
                >
                    <div class="col-sm-4">
                        <label for="default_task_receiver">
                            Default Task Receiver:
                            <i
                                class="fa fa-info-circle"
                                v-b-tooltip.hover="{
                                    placement: 'top',
                                    title: 'Receive unassigned tasks automatically'
                                }"
                                style="color: #cccccc"
                            ></i>
                        </label>
                    </div>
                    <div class="col-sm-8">
                        <span id="default_task_receiver">{{
                            details.unassigned == 1 ? "Yes" : "No"
                        }}</span>
                    </div>
                </div>
                <div class="row form-group p-1" v-if="details.is_provider == 1">
                    <div class="col-sm-4">
                        <label for="production_credit_id"
                            >Production Credit:</label
                        >
                    </div>
                    <div class="col-sm-8">
                        <span id="production_credit_id">{{
                            details.production_credit
                        }}</span>
                    </div>
                </div>
                <div class="row form-group p-1">
                    <div class="col-sm-4">
                        <label for="signature">Signature:</label>
                    </div>
                    <div
                        class="col-sm-8 cursor-pointer"
                        @click="
                            details.isactive &&
                                _hasAccess('setting.staff.update') &&
                                captureSignature()
                        "
                    >
                        <span
                            v-if="details.signature_img"
                            id="signature"
                            v-html="details.signature_img"
                        >
                        </span>
                        <span v-else>None</span>
                        <i
                            v-if="
                                details.isactive &&
                                _hasAccess('setting.staff.update')
                            "
                            class="fas fa-pen-square pl-2"
                            style="color: #cccccc; cursor: pointer"
                            v-b-tooltip.hover="{
                                placement: 'top',
                                title: 'Capture Signature'
                            }"
                        ></i>
                    </div>
                </div>
                <div
                    v-if="
                        details.is_provider == 1 &&
                        isCurrentActorProfile &&
                        details.vetsource_pin
                    "
                    class="row form-group p-1"
                >
                    <div class="col-sm-4">
                        <label for="vetsource_pin">VetSource PIN:</label>
                    </div>
                    <div class="col-sm-8">
                        <span id="vetsource_pin">{{
                            details.vetsource_pin
                        }}</span>
                    </div>
                </div>
            </div>
        </div>
        <modal-capture-signature
            ref="modalCaptureSignature"
        ></modal-capture-signature>
    </div>
</template>

<script>
import { STAFF_PROFILE_TAB_OPTIONS } from "@/store/staff.js";
import FeaturesEnabledMixin from "@/mixins/features-enabled";
import ModalCaptureSignature from "@/components/setting-staff/modal-capture-signature.vue";

export default {
    components: {
        ModalCaptureSignature
    },
    mixins: [FeaturesEnabledMixin],
    computed: {
        currentActor() {
            return this.$root.currentActor;
        },
        isCurrentActorProfile() {
            if (
                this.currentActor &&
                this.details &&
                this.currentActor.id == this.details.id
            ) {
                return true;
            } else {
                return false;
            }
        },
        details() {
            return this.$store.getters["staff/staffDetails"];
        },
        refresh() {
            return this.$store.getters["staff/refresh"];
        }
    },
    methods: {
        editProfile() {
            this.$store.commit(
                "staff/setStaffProfileTab",
                STAFF_PROFILE_TAB_OPTIONS.edit
            );
        },
        captureSignature() {
            this.$refs.modalCaptureSignature.open();
        }
    }
};
</script>
